<template>
  <v-container>
    <h1>
      <v-icon class="iconHeader">mdi-plus-circle-outline</v-icon>
      {{ $t("views.shops.new.header") }}
    </h1>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>